module.exports = __webpack_public_path__ + "img/cointelegraph.0da81b5d.png";